import { Injectable, OnDestroy } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { GetSummaryPayload } from '../models/dashboard.model';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DashboardService implements OnDestroy{ 
  private url = "api/dashboard";
  private headers = new HttpHeaders({ "Content-Type": "application/json" });
  options = { headers: this.headers };
  selectedDate$: Subject<any> = new Subject();
  ProductName$ = new BehaviorSubject(null);
  private destroy$ = new Subject<void>();
  constructor(private http: HttpClient) { }

  public GetGraphBlockSummary(payload:GetSummaryPayload) {
    return this.http.get(`/${this.url}/GetGraphBlockSummary?StartDate=${payload.startDate}&EndDate=${payload.endDate}`, this.options);
  }

  public GetShipmentStatusSummary(payload:GetSummaryPayload) {
    return this.http.get(`/${this.url}/GetShipmentStatusSummary?StartDate=${payload.startDate}&EndDate=${payload.endDate}`, this.options);
  }

  public GetTopProductsSummary(payload:GetSummaryPayload) {
    return this.http.get(`/${this.url}/GetTopProductsSummary?StartDate=${payload.startDate}&EndDate=${payload.endDate}`, this.options);
  }

  GetGraphSummary(payload:GetSummaryPayload) {
    return this.http.get(`/${this.url}/GetGraphSummary?StartDate=${payload.startDate}&EndDate=${payload.endDate}`, this.options);
  }

  GetGraphPriceyardSummary(payload:GetSummaryPayload){
    return this.http.get(`/${this.url}/GetGraphPriceyardSummary?StartDate=${payload.startDate}&EndDate=${payload.endDate}`, this.options);
  }

  public GetPlanyardRepenishSummary() {
    return this.http.get(`/${this.url}/GetPlanyardRepenishSummary`, this.options);
  }

  public GetPlanyardPurchaseSummary() {
    return this.http.get(`/${this.url}/GetPlanyardPurchaseSummary`, this.options);
  }

  GetGraphPlanyardSummary(payload) {
    return this.http.get(`/${this.url}/GetGraphPlanyardSummary?StartDate=${payload.startDate}&EndDate=${payload.endDate}`, this.options);
  }

  public GetGraphBlockPriceSummarry() {
    return this.http.get(`/${this.url}/GetGraphBlockPriceSummarry`, this.options);
  }

  public GetCompetingPriceyardSummary() {
    return this.http.get(`/${this.url}/GetCompetingPriceyardSummary`, this.options);
  }
  
  GetWinningProductPriceyardSummary(){
    return this.http.get(`/${this.url}/GetWinningProductPriceyardSummary`, this.options);
  }

  GetDashboardPurchasingSummaries(){
    return this.http.get(`/${this.url}/DashboardPurchasingSummaries`, this.options);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }

}

